import { render, staticRenderFns } from "./whatsNewGroup.vue?vue&type=template&id=68923a27&scoped=true&"
import script from "./whatsNewGroup.vue?vue&type=script&lang=js&"
export * from "./whatsNewGroup.vue?vue&type=script&lang=js&"
import style0 from "./whatsNewGroup.vue?vue&type=style&index=0&id=68923a27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68923a27",
  null
  
)

export default component.exports